import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ListToggleItem from './ListToggleItem';
import BackButton from './BackButton';
import Button from './Button';
import Notice from './Notice';
import { toast } from './Toast';
import Layout, { LayoutHeader, LayoutBody } from './Layout';
import Block, { BlockHeader } from './Block';
import { getString as s } from '../lib/strings';
import copyRef from '../lib/copyRef';
import Loader from './Loader';

const ChannelList = styled.div`
  margin-bottom: ${(props) => props.theme.whitespace.large};
`;
const ManageAll = styled(Notice)`
  text-align: center;
`;

class Channels extends Component {
  componentDidMount() {
    this.props.fetchPermissions();
  }
  toggleChannel = (permission, channel, currentValue) => {
    this.props.setChannel(permission, channel, !currentValue, this.props.userPermission);
  };
  render() {
    if (this.props.isChannelPosting === false) {
      if (this.props.channelError) {
        const title = s('channel.error.title', 'Sorry!');
        const body = s('channel.error.subtitle', 'There was a problem. Please refresh your browser.');
        toast.error(title, body);
      } else {
        const title = s('channel.change.title', 'Preferences Updated');
        const body = s(
          'channel.change.subtitle',
          'Changes may take several days to take effect'
        );
        toast.info(title, body);
      }
    }
    const { permission, channels, history, product, isFetching } = this.props;

    if(isFetching) return (<Loader isLoading={isFetching} />)

    return (
      <Layout className="channels">
        <LayoutHeader>
          <BackButton onClick={() => history.push(`/products/${product.id}`)}>
            {copyRef(product, 50)}
          </BackButton>
        </LayoutHeader>
        <LayoutBody brand={this.props.brand}>
          <Block>
            <BlockHeader
              primary={copyRef(permission, 'channel_title')}
              secondary={copyRef(permission, 'channel_description')}
            />
            <ChannelList id="channel_list">
              {channels
                .sort(
                  (a, b) =>
                    s(`channel.${a.type}.order`) - s(`channel.${b.type}.order`)
                )
                .filter ((channel) => (
                  permission.channels.includes(channel.type)
                ))
                .map((channel) => (
                  <ListToggleItem
                    name={channel.type}
                    key={`ch-${channel.type}`}
                    primary={s(
                      `channel.${channel.type}.displayName`,
                      channel.type
                    )}
                    checked={channel.allowed}
                    onClick={() =>
                      this.toggleChannel(
                        permission,
                        channel.type,
                        channel.allowed
                      )
                    }
                  />
                ))}
            </ChannelList>
            <ManageAll
              action={
                <Button
                  id="view_all_products"
                  onClick={() => history.push('/products/')}
                >
                  {s('channel.notice.button', 'View All Products')}
                </Button>
              }
            />
          </Block>
        </LayoutBody>
      </Layout>
    );
  }
}
Channels.propTypes = {
  permission: PropTypes.shape({
    id: PropTypes.string,
    channels: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  userPermission: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  fetchPermissions: PropTypes.func.isRequired,
  setChannel: PropTypes.func.isRequired,
  channels: PropTypes.arrayOf(PropTypes.object),
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  product: PropTypes.shape({
    displayName: PropTypes.string,
    id: PropTypes.string
  }).isRequired,
  isFetching: PropTypes.bool,
  isChannelPosting: PropTypes.bool,
  channelError: PropTypes.string,
  brand: PropTypes.string
};
Channels.defaultProps = {
  channels: [],
  isFetching: undefined,
  isChannelPosting: undefined,
  channelError: false
};

export default Channels;
